import { useQuery } from "@tanstack/react-query"

import { getContract, listContracts } from "@/features/contracts/api/contracts.api"

export const contractsKeys = {
  all: ["contracts"] as const,
  list: () => [...contractsKeys.all, "list"] as const,
  detail: (id: string) => [...contractsKeys.all, "detail", id] as const,
}

export function useContracts() {
  return useQuery({
    queryKey: contractsKeys.list(),
    queryFn: listContracts,
  })
}

export function useContract(contractId: string | undefined) {
  return useQuery({
    queryKey: contractsKeys.detail(contractId ?? ""),
    queryFn: () => getContract(contractId as string),
    enabled: !!contractId,
  })
}
